import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getUrlIdsFromNavigationPath } from "@faire/retailer-shared/categories/navigationPath";
import { QueryParameters } from "@faire/retailer-visitor-shared/paths/category/QueryParameters";
import { CategoryPagePaths } from "@faire/retailer-visitor-shared/paths/CategoryPage";
import { findActiveCategoryByUrlIds } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByUrlId";
import { route as homepageRoute } from "@faire/web-api--source/routes/www/root";
export var getCategoryRedirect = function(category, param, categories, routingContext) {
    var match = param.match, location = param.location;
    var _match_params = match.params, brandValue = _match_params.brandValue, c1SuppliersUrlId = _match_params.c1SuppliersUrlId;
    if (category === undefined) {
        return homepageRoute;
    }
    var categoryUrlIds = category.urlIdStrings;
    // If the category exists, don't redirect
    if (findActiveCategoryByUrlIds(categoryUrlIds, categories) !== undefined) {
        return undefined;
    }
    var categoryPathParams = {
        queryParams: QueryParameters.parse(location.search),
        routeType: CategoryPagePaths.getRouteType(c1SuppliersUrlId),
        filterByBrandValueOption: brandValue
    };
    // First check if there is a redirect in the category tree
    var redirectUrlInCategoryTree = findRedirectInCategoryTree(categoryUrlIds, categories);
    if (redirectUrlInCategoryTree !== undefined) {
        return CategoryPagePaths.index(_object_spread_props(_object_spread({
            categoryUrlIds: redirectUrlInCategoryTree.map(function(urlId) {
                return {
                    id: urlId
                };
            })
        }, categoryPathParams), {
            routingContext: routingContext
        }));
    }
    var validCategoryUrlIds = [
        category.urlId
    ];
    // Because it is possible to have inactive seasonal categories which return results but do NOT exist in the tree
    // Cannot validate that the root category has a path identifier
    // This logic should be removable once all seasonal categories are migrated to the navigation tree
    var categoryToValidate = category.subCategory;
    // If subcategories don't have path identifiers, they are not in the tree.
    // So redirect to the closest ancestor that exists or the closest C1.
    while(categoryToValidate !== undefined){
        if (categoryToValidate.pathIdentifier === undefined) {
            return CategoryPagePaths.index(_object_spread_props(_object_spread({
                categoryUrlIds: validCategoryUrlIds
            }, categoryPathParams), {
                routingContext: routingContext
            }));
        }
        validCategoryUrlIds.push(categoryToValidate.urlId);
        categoryToValidate = categoryToValidate.subCategory;
    }
    return undefined;
};
/**
 * Looks through the category tree to find a redirect for the given category url ids
 * The redirect information for a category is stored in the redirect_navigation_paths
 * which represents the navigation path which redirect into it
 *
 * @param urlIds url ids of the category which we are trying to find a redirect for
 * @param categories category tree to search for redirects
 * @returns
 */ var findRedirectInCategoryTree = function(urlIds, categories) {
    // Build a map of redirects for the current categories in the tree
    // Done to allow for easier lookup algorithm and potential caching of the map
    // if needed for performance
    var redirectMap = {};
    buildRedirectMapForCategories(redirectMap, categories, []);
    var redirectNode = redirectMap;
    var categoryUrlIds = urlIds.map(function(urlId) {
        return urlId.toLowerCase();
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = categoryUrlIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var urlId = _step.value;
            redirectNode = redirectNode[urlId];
            if (redirectNode === undefined) {
                return undefined;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return redirectNode === null || redirectNode === void 0 ? void 0 : redirectNode.redirect;
};
/**
 * Build a map of redirects for the given categories and their subcategories.
 * The resulting map is a tree structure where each key represents the category redirect for that category
 * The category that the url id maps to is foudn under the redirect property.
 * All other keys represent the redirect info for the child
 *
 * @param redirectMap Map object to be built. Modified in place
 * @param categories Categories to build the map for
 * @param parentUrlIds The parents url ids of the categories passed in. For example if this is a
 * group of L2 catgories, the parentUrlIds would be the url id of the L1 category
 */ var buildRedirectMapForCategories = function(redirectMap, categories, parentUrlIds) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            if (category.url_id === undefined) {
                continue;
            }
            var currentCategoryNavigationPath = _to_consumable_array(parentUrlIds).concat([
                category.url_id
            ]);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = category.redirect_navigation_paths[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var redirectNavigationPath = _step1.value;
                    addRedirectNode(redirectMap, getUrlIdsFromNavigationPath(redirectNavigationPath), currentCategoryNavigationPath);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            buildRedirectMapForCategories(redirectMap, category.sub_categories, currentCategoryNavigationPath);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
/**
 * Adds an entry into the redirect map for the given redirect url ids
 *
 * @param redirectMap Map to add the redirect node to. Modified in place
 * @param redirectUrlIds The category url ids that should redirect
 * @param targetUrlIds The category url id the redirectUrlIds should redirect to
 */ var addRedirectNode = function(redirectMap, redirectUrlIds, targetUrlIds) {
    var currentNode = redirectMap;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = redirectUrlIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var urlId = _step.value;
            var normalizedUrlId = urlId.toLowerCase();
            var _currentNode_normalizedUrlId;
            var node = (_currentNode_normalizedUrlId = currentNode[normalizedUrlId]) !== null && _currentNode_normalizedUrlId !== void 0 ? _currentNode_normalizedUrlId : {};
            if (currentNode[normalizedUrlId] === undefined) {
                currentNode[normalizedUrlId] = node;
            }
            currentNode = node;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    currentNode.redirect = targetUrlIds;
};
